import React from 'react';

import CreateEditPersonnelFormUI from '../CreateEditPersonnelFormUI';

const EditPersonnelDialog = (props) => {
  const {
    openDialog,
    openCreatePersonnelDialog,
    onHandleInputChange,
    personnel,
    submitPersonnel,
    isSaving,
    branches,
    sites
  } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...personnel,
      personnelTypeId: personnel.personnelType
    };
    submitPersonnel(payload);
  };

  return (
    <React.Fragment>
      <CreateEditPersonnelFormUI
        openDialog={openDialog}
        openCreatePersonnelDialog={openCreatePersonnelDialog}
        onHandleInputChange={onHandleInputChange}
        personnel={personnel}
        isSaving={isSaving}
        branches={branches}
        handleSubmit={handleSubmit}
        sites={sites}
        title="Personnel Detail"
        actionButtonText="Update"
      />
    </React.Fragment>
  );
};

export default EditPersonnelDialog;
